module.exports = __webpack_public_path__ + "static/media/chevron-down-blue-ic.e20580df.svg";